<template>
  <div v-if="dataSeriesIsEmpty">
    <h1 class="mb-2 text-center text-lg font-medium text-gray-800 md:text-lg">
      {{ chartTitle }}
    </h1>
    <div class="mt-7 w-[380px]">
      <apex-chart
        type="donut"
        :options="assetPieChartOptions"
        :series="assetChartSeries"
      />
    </div>
  </div>
</template>

<script>
import randomColor from 'randomcolor'

export default {
  name: 'AssetChartBreakdown',

  props: {
    chartSeries: {
      type: Array,
      required: true,
    },
    chartTitle: {
      type: String,
      default: 'Chart title',
    },
  },

  data() {
    return {
      assetChartSeries: this.chartSeries,
      assetPieChartOptions: {
        chart: {
          type: 'donut',
          width: 380,
        },
        labels: [],
        colors: [],
        stroke: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        yaxis: {
          labels: {
            formatter(value) {
              return thousands(value, 3)
            },
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: 'Total',
                  fontFamily: 'Inter, sans-serif',
                  formatter(w) {
                    const total = w.globals.seriesTotals.reduce(
                      (a, b) => a + b,
                      0,
                    )
                    return thousands(total, 3)
                  },
                },
                value: {
                  show: true,
                  fontSize: '20px',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 600,
                  color: undefined,
                  formatter(val) {
                    return thousands(val, 3)
                  },
                },
                formatter(val) {
                  return thousands(val, 3)
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 380,
              },
              legend: {
                show: false,
              },
              dataLabels: {
                enabled: false,
              },
            },
          },
        ],
      },
    }
  },

  computed: {
    dataSeriesIsEmpty() {
      return [...this.assetChartSeries].reduce((a, b) => a + b, 0)
    },
  },

  watch: {
    chartSeries(newSeries) {
      this.assetChartSeries = newSeries
      this.updatedLabelsPieChart(newSeries)
    },
  },

  methods: {
    updatedLabelsPieChart(data) {
      if (data.length) {
        this.assetChartSeries = []
        this.assetPieChartOptions.labels = []
        this.assetPieChartOptions.colors = []
        data.forEach(({ asset_name, total_emissions }) => {
          this.assetChartSeries.push(Number(total_emissions.toFixed(4)))
          this.assetPieChartOptions.labels.push(asset_name)
          this.assetPieChartOptions.colors.push(
            randomColor({
              luminosity: 'dark',
              hue: 'random',
              // keep the same color for the same asset
              seed: asset_name,
            }),
          )
        })
      }
    },
  },
}
</script>
